// src/api/meeting.js
import api from "./axios";

export function getMyUserIdFromToken() {
  try {
    const t = localStorage.getItem("access");
    if (!t) return null;
    const [, p] = t.split(".");
    const json = JSON.parse(atob(p.replace(/-/g, "+").replace(/_/g, "/")));
    return json.user_id ?? json.user?.id ?? null;
  } catch {
    return null;
  }
}

export const meetingApi = {
  // 기본적으로 삭제된 문서(soft-delete) 제외
  list: (params) =>
    api.get("/meeting/meetings/", {
      params: { include_deleted: 0, ...(params || {}) },
    }),
  retrieve: (id) => api.get(`/meeting/meetings/${id}/`),
  create: (data) => api.post("/meeting/meetings/", data),
  update: (id, data) => api.patch(`/meeting/meetings/${id}/`, data),
  remove: (id) => api.delete(`/meeting/meetings/${id}/`),
  me: () => api.get("/meeting/meetings/me/"),
  // 프로젝트 사용자 목록 (본인 포함)
  projectUsers: (projectId, params) =>
    api.get(`/project/${projectId}/users/`, { params }),
  rsvp: (id, isAttending) =>
    api.post(`/meeting/meetings/${id}/rsvp/`, { is_attending: !!isAttending }),
  rsvpReset: (id) => api.post(`/meeting/meetings/${id}/reset_rsvp/`),
  attachments: {
    list: (mid) => api.get(`/meeting/meetings/${mid}/attachments/`),

    // 새로 추가: JWT를 붙여 직접 파일을 받아 blob으로 반환
    // PaperFile 직접 다운로드(Fetch로 blob)
    download: async (_mid, fileId) => {
      const token = localStorage.getItem("access");
      const res = await fetch(`/api/papers/files/${fileId}/download/`, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      });
      if (!res.ok) {
        const msg = await res.text().catch(() => "");
        throw new Error(`download failed: ${res.status} ${msg}`);
      }
      const cd = res.headers.get("Content-Disposition") || "";
      // filename*=UTF-8''... 우선 파싱, 없으면 filename="..."
      let encoded = (
        cd.match(/filename\*=(?:UTF-8'')?([^;]+)/i)?.[1] || ""
      ).replace(/^"+|"+$/g, "");
      let filename = "";
      if (encoded) {
        try {
          filename = decodeURIComponent(encoded);
        } catch {}
      }
      if (!filename) {
        filename = cd.match(/filename="?([^"]+)"?/i)?.[1] || "";
      }
      // 경로 분리자 무력화(보안/플랫폼 호환)
      filename = filename.replace(/[\/\\]+/g, "_");
      const blob = await res.blob();
      return { blob, filename };
    },

    // 회의 첨부 업로드 → meeting/attachments(프록시)로 보내면 서버가 PaperFile.create(doc_dns=회의문서)
    upload: async (mid, file) => {
      const fd = new FormData();
      fd.append("file", file);

      const token = localStorage.getItem("access");
      const res = await fetch(`/api/meeting/meetings/${mid}/attachments/`, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        body: fd,
      });

      if (!res.ok) {
        let msg = await res.text().catch(() => "");
        try {
          const j = JSON.parse(msg);
          if (j && j.detail) msg = j.detail;
        } catch {}
        throw new Error(msg || `upload failed: ${res.status}`);
      }
      return res.json();
    },

    // 연결 해제(회의 문서와의 링크 제거, 사용처 없으면 파일 삭제)
    remove: (mid, fileId) =>
      api.post(`/meeting/meetings/${mid}/attachments/${fileId}/unlink/`),

    linkFromLibrary: (mid, paperFileIds) =>
      api.post(`/meeting/meetings/${mid}/attachments/link-from-library/`, {
        paper_file_ids: paperFileIds,
      }),
  },
  rooms: {
    list: (params) => api.get("/meeting/rooms/", { params }),
    create: (data) => api.post("/meeting/rooms/", data),
    update: (id, data) => api.patch(`/meeting/rooms/${id}/`, data),
    remove: (id) => api.delete(`/meeting/rooms/${id}/`),
    reorder: (project, orderedIds) =>
      api.post("/meeting/rooms/reorder/", {
        project,
        ordered_ids: orderedIds,
      }),
  },
};

//공지사항

export const getNotices = (params) => {
  return api.get("/meeting/notices/", { params });
};

export const getNoticeDetail = (id) => {
  return api.get(`/meeting/notices/${id}/`);
};

export const createNotice = (data) => {
  return api.post("/meeting/notices/create/", data);
};

export const updateNotice = (id, data) => {
  return api.put(`/meeting/notices/${id}/update/`, data);
};

export const deleteNotice = (id) => {
  return api.delete(`/meeting/notices/${id}/delete/`);
};
